import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-jaspreet',
  templateUrl: './jaspreet.component.html',
  styleUrls: ['./jaspreet.component.scss']
})
export class JaspreetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getJaspreet();
  }
}
